module.exports = __webpack_public_path__ + "static/razorpayLogo-c645a5442d683b3a218fa6876062e852.png";